import api from './axios';

export function getDiscounts() {
  return api.get('/api/discount');
}

export function createDiscount(data) {
  return api.post('/api/discount/create', data);
}

export function updateDiscount(id, data) {
  return api.put(`/api/discount/${id}`, data);
}

export function deleteDiscount(id) {
  return api.delete(`/api/discount/${id}`);
}

export function toggleDiscount(id) {
  return api.post(`/api/discount/toggle/${id}`);
}
